'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _GridStyleSheet = require('./GridStyleSheet');

var _GridStyleSheet2 = _interopRequireDefault(_GridStyleSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Grid(props) {
  var _classNames;

  var innerRef = props.innerRef,
      alignContent = props.alignContent,
      alignItems = props.alignItems,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      container = props.container,
      direction = props.direction,
      hidden = props.hidden,
      flex = props.flex,
      item = props.item,
      justify = props.justify,
      lg = props.lg,
      md = props.md,
      zeroMinWidth = props.zeroMinWidth,
      sm = props.sm,
      spacing = props.spacing,
      wrap = props.wrap,
      xl = props.xl,
      xs = props.xs,
      theme = props.theme,
      other = _objectWithoutProperties(props, ['innerRef', 'alignContent', 'alignItems', 'classes', 'className', 'component', 'container', 'direction', 'hidden', 'flex', 'item', 'justify', 'lg', 'md', 'zeroMinWidth', 'sm', 'spacing', 'wrap', 'xl', 'xs', 'theme']);

  var className = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, classes.typeContainer, container), _defineProperty(_classNames, classes.typeItem, item), _defineProperty(_classNames, classes.zeroMinWidth, zeroMinWidth), _defineProperty(_classNames, classes.flex, flex), _defineProperty(_classNames, classes['spacing-xs-' + String(spacing)], container && spacing !== 0), _defineProperty(_classNames, classes['direction-xs-' + String(direction)], direction !== Grid.defaultProps.direction), _defineProperty(_classNames, classes['wrap-xs-' + String(wrap)], wrap !== Grid.defaultProps.wrap), _defineProperty(_classNames, classes['align-items-xs-' + String(alignItems)], alignItems !== Grid.defaultProps.alignItems), _defineProperty(_classNames, classes['align-content-xs-' + String(alignContent)], alignContent !== Grid.defaultProps.alignContent), _defineProperty(_classNames, classes['justify-xs-' + String(justify)], justify !== Grid.defaultProps.justify), _defineProperty(_classNames, classes['grid-xs'], xs === true), _defineProperty(_classNames, classes['grid-xs-' + String(xs)], xs && xs !== true), _defineProperty(_classNames, classes['grid-sm'], sm === true), _defineProperty(_classNames, classes['grid-sm-' + String(sm)], sm && sm !== true), _defineProperty(_classNames, classes['grid-md'], md === true), _defineProperty(_classNames, classes['grid-md-' + String(md)], md && md !== true), _defineProperty(_classNames, classes['grid-lg'], lg === true), _defineProperty(_classNames, classes['grid-lg-' + String(lg)], lg && lg !== true), _defineProperty(_classNames, classes['grid-xl'], xl === true), _defineProperty(_classNames, classes['grid-xl-' + String(xl)], xl && xl !== true), _classNames), classNameProp);

  var gridProps = _extends({ className: className }, other);

  return _react2.default.createElement(Component, _extends({ ref: innerRef }, gridProps));
}

Grid.displayName = 'Grid';
Grid.propTypes = {
  alignContent: _propTypes2.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  alignItems: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  children: _propTypes2.default.node,

  classes: _propTypes2.default.object.isRequired,

  className: _propTypes2.default.string,

  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),

  container: _propTypes2.default.bool,

  direction: _propTypes2.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  hidden: _propTypes2.default.object,

  flex: _propTypes2.default.bool,

  item: _propTypes2.default.bool,

  justify: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),

  lg: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  md: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  sm: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  spacing: _propTypes2.default.oneOf(_GridStyleSheet.GUTTERS),

  wrap: _propTypes2.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  xl: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  xs: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  zeroMinWidth: _propTypes2.default.bool,

  innerRef: _propTypes2.default.func
};

Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  component: 'div',
  container: false,
  flex: false,
  direction: 'row',
  item: false,
  justify: 'flex-start',
  zeroMinWidth: false,
  spacing: 16,
  wrap: 'wrap',
  innerRef: null
};

exports.default = (0, _reactJss2.default)(_GridStyleSheet2.default, { name: 'JssGrid' })(Grid);